import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden")
    }
  }

  close() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add("hidden")
    }
  }
}
